module.exports = __webpack_public_path__ + "static/media/instagram.32f4793f.svg";